import { render, staticRenderFns } from "./KillistAdd.vue?vue&type=template&id=19ce2ab2&"
import script from "./KillistAdd.vue?vue&type=script&lang=js&"
export * from "./KillistAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports